export default __webpack_public_path__ + "682de8eb40bed73c5975f7fdb35a3c01.png";